// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .text-search-bar {
  padding-top: 8px;
  padding-bottom: 8px;
}
:host .text-search-bar ::ng-deep .searchbar-input::placeholder {
  font-size: 14px;
}
:host .searchbar-md .searchbar-input {
  font-size: 1.3rem;
}
:host .location {
  position: fixed;
  right: 65px;
  z-index: 99;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
